import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import SharePost from "../../../components/sharePost/SharePost";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const ResearcherLikeCommentActions = ({
  postId,
  type,
  is_Liked,
  likeCount,
  views,
  isOpen,
  onLikeUpdate,
  postOwnerId,
}) => {
  const navigate=useNavigate()
 const [isLiked, setIsLiked] = useState(false);
const [likedCount, setLikedCount] = useState(0);
const [likeLoading, setLikeLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);
  // console.log("The current user is:",currentUserId)
  const [currentUser, setCurrentUser] = useState(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editText, setEditText] = useState("");
  const [loading, setLoading] = useState(false);
  const postUrl = `/post/${postId}?type=${type}`;
  const token = localStorage.getItem("access_token");
  const [showShareModal, setShowShareModal] = useState(false);
  const [postOwner, setPostOwner] = useState(null);
  const handleEdit = (comment) => {
    setEditingCommentId(comment.id);
    setEditText(comment.text);
  };
  const commentsEndRef = useRef(null);

  const saveEdit = async (id) => {
    try {
      await axios.patch(
        `${BASE_URL}/marketplace/researcher/edit-comment/`,
        {
          id: id,
          text: editText,
        },
        {
          headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        }
      );
      setEditingCommentId(null);
      fetchComments();
      toast.success("Comment updated");
    } catch (error) {
      console.error("Error editing comment:", error);
      toast.error("Failed to edit comment");
    }
  };

  const fetchCurrentUser = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY, },
      });
      const data = await res.json();
      if (res.ok) {
        setCurrentUserId(data.data);
        setCurrentUser(data.data);
        localStorage.setItem("user_id", data.data?.user);
      } else {
        console.error("");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error getting user profile.");
    }
  }, [BASE_URL, token]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  // Sync like state with props from parent
useEffect(() => {
  setIsLiked(!!is_Liked);
  setLikedCount(likeCount ?? 0);
}, [is_Liked, likeCount]);

const handleLike = async () => {
  if (likeLoading) return;

  setLikeLoading(true);

  try {
    const res = await axios.post(
      `${BASE_URL}/marketplace/researcher/like-toggle/`,
      { type, id: postId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );

    const { is_liked, like_count } = res.data;

    console.log("The response is:", res.data);

    // 🔥 FIXED LINE
    onLikeUpdate?.({
      id: postId,
      is_liked,
      like_count,
    });

    setIsLiked(is_liked);
    setLikedCount(like_count);

  } catch (err) {
    console.error(err);
  } finally {
    setLikeLoading(false);
  }
};
  const handleComment = async () => {
    // console.log(id, type, commentText);
    try {
      setLoading(true);
      await axios.post(
        `${BASE_URL}/marketplace/researcher/add-comment/`,
        { type, id: postId, text: commentText },
        { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      setCommentText("");
      fetchComments();
    } catch (error) {
      console.error("Error posting comment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (commentId) => {
    try {
      const res = await axios.delete(`${BASE_URL}/marketplace/researcher/delete-comment/`, {
        data: { id: commentId },
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });
      fetchComments();
      toast.success("Comment deleted");
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment");
    }
  };
  const fetchComments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/marketplace/researcher/get-comments/`, {
        params: { type, id: postId },
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });
      const commentList = Array.isArray(res.data) ? res.data : res.data?.results || [];
      setComments(
        commentList.map((c) => ({
          id: c.id,
          author: c.profile_data?.name || "Unknown",
          avatar: c.profile_data?.profile_picture || "",
          text: c.text,
          userId: c.profile_data?.id,
        }))
      );
      if (res.data?.post_owner != null) {
        setPostOwner(res.data.post_owner);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };
  useEffect(() => {
    if (postOwnerId != null) {
      setPostOwner(postOwnerId);
    }
  }, [postOwnerId]);

  useEffect(() => {
    if (currentUserId) {
      fetchComments();
    }
  }, [postId, type, currentUserId]);
  <div
    className="comments-box"
    style={{ maxHeight: "200px", overflowY: "auto" }}
  >
    {comments.map((c) => (
      <div key={c.id}>{/* comment content */}</div>
    ))}
    <div ref={commentsEndRef} />
  </div>;
  return (
   <div onClick={(e) => e.stopPropagation()}>
  {/* Action Buttons */}
  <div className="flex gap-0  pt-3 ">
    {/* Like Button */}
    <button
  disabled={likeLoading}
  onClick={(e) => {
    e.stopPropagation();
    handleLike();
  }}
  className={`flex items-center gap-2 px-3 py-2 rounded-xl transition-colors ${
    isLiked
      ? "text-red-500 bg-red-50"
      : "text-gray-600 hover:bg-gray-100"
  } ${likeLoading ? "opacity-60 cursor-not-allowed" : ""}`}
>
  <svg
    className="w-5 h-5"
    fill={isLiked ? "currentColor" : "none"}
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={isLiked ? "0" : "2"}
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    />
  </svg>

  <span className="text-sm font-medium">
    {likedCount} {likedCount === 1 ? "Like" : "Likes"}
  </span>
</button>

     {
        views && <div className="flex items-center gap-1 text-gray-600 text-sm">
  <Eye className="w-4 h-4" />
  <span>{views}</span>
</div>
     }
    {/* Comment Button */}
    <button
      className="flex items-center gap-2 px-3 py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors"
      onClick={(e) => {
        e.stopPropagation();
        setShowCommentModal((prev) => !prev);
      }}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      <span className="text-sm font-medium">
        Comments {comments.length > 0 && <span className="text-gray-500">({comments.length})</span>}
      </span>
    </button>
    {/* Share Button */}
    <button
      className="flex items-center gap-2 px-3 py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors"
      onClick={(e) => {
        e.stopPropagation();
        setShowShareModal(true);
      }}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
      </svg>
      <span className="text-sm font-medium">Share</span>
    </button>
    {showShareModal && (
      <SharePost
        postId={postId}
        postLink={postUrl}
        onClose={() => setShowShareModal(false)}
        isTrue={true}
      />
    )}
  </div>
  {/* Comments Section */}
  {
    isOpen ?   <div className="mt-6 pt-6 border-t border-gray-100">
      <div className="mb-4">
        <h4 className="font-medium text-gray-900 mb-3">Comments ({comments.length})</h4>
        
        {comments.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <p className="text-gray-500">No comments yet</p>
          </div>
        ) : (
          <div className="space-y-4 max-h-[45vh] overflow-y-auto pr-2">
            {comments.map((c) => (
              <div className="flex items-start gap-3" key={c.id}>
                <img
                  src={c.avatar || currentUser?.profile_picture}
                  alt="User"
                  className="w-9 h-9 rounded-full object-cover border border-gray-200"
                  onClick={()=>navigate(`${currentUser?.id === c.userId ? "/profile-view" : `/user-profile/${c.userId}`}`)}
                />
                <div className="flex-1">
                  <div className="bg-slate-50 rounded-xl p-3">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-medium text-sm text-gray-900">{c.author}</span>
                      {currentUser?.id === c.userId && (
                        <div className="flex gap-1">
                          <button
                            className="p-1 text-gray-400 hover:text-gray-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(c);
                            }}
                          >
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          {currentUser?.id === c.userId && (
                            <button
                              className="p-1 text-gray-400 hover:text-red-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(c.id);
                              }}
                            >
                              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    
                    {editingCommentId === c.id ? (
                      <div className="mt-2">
                        <input
                          type="text"
                          value={editText}
                          onChange={(e) => setEditText(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                        />
                        <div className="flex gap-2 mt-2">
                          <button
                            className="px-3 py-1 bg-[#0f6abf] text-white text-sm rounded-lg"
                            onClick={() => saveEdit(c.id)}
                          >
                            Save
                          </button>
                          <button
                            className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded-lg"
                            onClick={() => setEditingCommentId(null)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm text-gray-700">{c.text}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Comment Input */}
      <div className="w-full pr-6 absolute bottom-1 bg-white flex items-center gap-3" >
        <img
          src={currentUserId?.profile_picture}
          alt="Me"
          className="w-9 h-9 rounded-full object-cover border border-gray-200"
          onClick={()=>navigate("/profile-view")}
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleComment();
            
          }}
          className="flex-1 flex gap-2"
        >
          <input
            type="text"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            
            placeholder="Write a comment..."
            className="flex-1 px-4 py-2.5 border border-gray-300 rounded-full text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
          />
          <button
            className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-full hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Posting...
              </div>
            ) : (
              "Post"
            )}
          </button>
        </form>
      </div>
    </div> :
    showCommentModal && (
    <div className="mt-6 pt-6 border-t border-gray-100">
      <div className="mb-4">
        <h4 className="font-medium text-gray-900 mb-3">Comments ({comments.length})</h4>
        
        {comments.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <p className="text-gray-500">No comments yet</p>
          </div>
        ) : (
          <div className="space-y-4 max-h-60 overflow-y-auto pr-2">
            {comments.map((c) => (
              <div className="flex items-start gap-3" key={c.id}>
                <img
                  src={c.avatar || currentUser?.profile_picture}
                  alt="User"
                  className="w-9 h-9 rounded-full object-cover border border-gray-200"
                  onClick={()=>navigate(`${currentUser?.id === c.userId ? "/profile-view" : `/user-profile/${c.userId}`}`)}
                />
                <div className="flex-1">
                  <div className="bg-slate-50 rounded-xl p-3">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-medium text-sm text-gray-900">{c.author}</span>
                      {currentUser?.id === c.userId && (
                        <div className="flex gap-1">
                          <button
                            className="p-1 text-gray-400 hover:text-gray-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(c);
                            }}
                          >
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          {currentUser?.id === c.userId && (
                            <button
                              className="p-1 text-gray-400 hover:text-red-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(c.id);
                              }}
                            >
                              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    
                    {editingCommentId === c.id ? (
                      <div className="mt-2">
                        <input
                          type="text"
                          value={editText}
                          onChange={(e) => setEditText(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                        />
                        <div className="flex gap-2 mt-2">
                          <button
                            className="px-3 py-1 bg-[#0f6abf] text-white text-sm rounded-lg"
                            onClick={() => saveEdit(c.id)}
                          >
                            Save
                          </button>
                          <button
                            className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded-lg"
                            onClick={() => setEditingCommentId(null)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm text-gray-700">{c.text}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Comment Input */}
      <div className="flex items-center gap-3">
        <img
          src={currentUserId?.profile_picture}
          alt="Me"
          className="w-9 h-9 rounded-full object-cover border border-gray-200"
          onClick={()=>navigate("/profile-view")}
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleComment();
          }}
          className="flex-1 flex gap-2"
        >
          <input
            type="text"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            placeholder="Write a comment..."
            className="flex-1 px-4 py-2.5 border border-gray-300 rounded-full text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
          />
          <button
            className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-full hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Posting...
              </div>
            ) : (
              "Post"
            )}
          </button>
        </form>
      </div>
    </div>
  )
  }
</div>
  );
};

export default ResearcherLikeCommentActions;
